import { Outlet, useLocation } from 'react-router'
import { motion } from 'framer-motion'
import useHelmet from '../../utilities/hooks/helmet/useHelmet'
import { useRouteFrame } from '../frame'
import classNames from 'classnames'
const FundLayout = ({ helmet }: { helmet: string }) => {
    const { pathname } = useLocation()
    useHelmet(helmet)
    useRouteFrame()
    const isSettlement = pathname.includes('settlement-exit')

    return (
        <div className="sm:w-full app-frame md:bg-bg-md-screen h-full">
            <div
                className={classNames(isSettlement ? 'bg-main-bg' : 'bg-white')}
            >
                <motion.div
                    key={pathname}
                    initial={{ opacity: 0, x: '100%' }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: '-100%' }}
                    transition={{ duration: 0.2 }}
                    className="w-100 sm:vh-100 md:min-h-screen"
                >
                    <Outlet />
                </motion.div>
            </div>
        </div>
    )
}

export default FundLayout
